import { BrandColors } from '../theme';

export const tabsTokens = {
    tablist: {
        borderWidth: '0 0 1px 0',
        background: 'transparent',
        borderColor: BrandColors.semantic.border,
    },
    tab: {
        background: 'transparent',
        hoverBackground: BrandColors.surface[100],
        activeBackground: 'transparent',
        borderWidth: '0 0 1px 0',
        borderColor: 'transparent',
        hoverBorderColor: BrandColors.primary[300],
        activeBorderColor: BrandColors.primary[500],
        color: BrandColors.surface[500],
        hoverColor: BrandColors.surface[700],
        activeColor: BrandColors.primary[500],
        padding: '0.75rem 1rem',
    },
};
